import React, { useState } from 'react';
import { List, Typography, Divider, useTheme } from '@mui/material';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

const SidebarMenuItems = ({ menuItems }) => {
  const theme = useTheme();
  const [openBranch, setOpenBranch] = useState(null);

  const handleBranchToggle = (branchId) => {
    setOpenBranch(prev => prev === branchId ? null : branchId);
  };

  return (
    <List>
      {menuItems.map((group, index) => (
        <React.Fragment key={group.id}>
          {index !== 0 && (
            <Divider
              sx={{
                mt: 3,
                mx: 1,
                borderColor: theme.palette.border.main,
                opacity: 0.4,
              }}
            />
          )}
          <Typography variant="subtitle1" sx={{ mt: index === 0 ? 2 : 3, paddingBottom: 2, textAlign: 'right', fontWeight: 'bold', fontFamily: 'Vazirmatn', color: theme.palette.text.default }}>
            {group.title}
          </Typography>
          {group.children.map((item) =>
            item.children ? (
              <NavCollapse 
                key={item.id} 
                item={item} 
                level={1} 
                isOpen={openBranch === item.id}
                onToggle={() => handleBranchToggle(item.id)}
              />
            ) : (
              <NavItem key={item.id} item={item} level={1} />
            )
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default SidebarMenuItems;
